import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { flattenRules } from "@shared/productOfferingsUtils";
import { AppState } from "../../../types/redux";
import { SectionWrapper } from "../../UI/SectionWrapper/SectionWrapper";

const ROOM_TYPE = "roomType";

interface IProductOfferingRoomTypesProps {
  offering: any;
}

export const ProductOfferingRoomTypes: React.FC<
  IProductOfferingRoomTypesProps
> = ({ offering }) => {
  const { hotelChainId } = useParams<{ hotelChainId: string }>();

  const hotelChain = useSelector((state: AppState) =>
    state.organizationUnits.organizationUnits.find(
      ({ _id }) => _id === hotelChainId
    )
  );

  const roomTypeNames = flattenRules(offering?.labelRule || [])
    .filter((rule) => rule.eq && rule.eq.key === ROOM_TYPE)
    .map((rule) => {
      const roomTypeId = rule.eq!.value;
      const roomType = hotelChain?.roomTypes.find(
        ({ _id }) => _id === roomTypeId
      );
      return roomType?.name || roomTypeId;
    });

  return (
    <SectionWrapper>
      <h4>Room types</h4>
      {roomTypeNames.length ? (
        <ul>
          {roomTypeNames.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      ) : (
        <span>No room types</span>
      )}
    </SectionWrapper>
  );
};
